export default "__VITE_ASSET__$5bg5HmX__"